module.exports = __webpack_public_path__ + "img/election2016.9c2efe43.jpg";